<template>
    <div class="env-block row"
         v-bind:class="{ active: envitem.active}">
        <img :src="'/'+envitem.image" />
        {{envitem.title}} -
        {{envitem.image}}
    </div>
</template>

<script>
    export default {
        name: "NavEnvBlock",
        props: ['envitem'],
        data() {
            return {}
        }
    }
</script>

<style lang="scss" scoped>

</style>